import { Flex, Text } from "@hopper-ui/components";
import { Skeleton } from "@sg-protect/components";
import type { ReactNode } from "react";
import type { FiguresState } from "#utils/dataSources.ts";

export interface AssessmentSectionCardProps {
    label: string;
    icon?: ReactNode;
    total?: FiguresState;
}

// PLACEHOLDER: "Unavailable" copy; confirm with design
function renderTotal(total: FiguresState) {
    switch (total.kind) {
        case "none":
            return null;
        case "loading":
        case "computing":
            return <Skeleton isInline width="4rem" height="1.5rem" />;
        case "unavailable":
        case "failed":
            return (
                <Text size="xs" color="danger" data-public>
                    Unavailable
                </Text>
            );
        case "ready":
            return (
                <Text fontFamily="heading-lg" fontSize="heading-lg" fontWeight="heading-lg" lineHeight="heading-lg">
                    {total.text}
                </Text>
            );
    }
}

export function AssessmentSectionCard({ label, icon, total = { kind: "none" } }: AssessmentSectionCardProps) {
    return (
        <Flex direction="column" justifyContent="center" gap="stack-xs" minHeight="core_640" width="100%">
            {renderTotal(total)}
            <Flex alignItems="center" gap="inline-xs">
                {icon}
                <Text color="neutral-weak">{label}</Text>
            </Flex>
        </Flex>
    );
}
